import type { RouteResource } from 'react-resource-router';

import { eocCommonResources, type UserResourceType } from '@atlassian/eoc-resources';
import {
	getTimeTemplatesResource,
	type GetTimeTemplatesResponse,
	getTimezonesResource,
	type GetTimezonesResponse,
} from '@atlassian/eoc-schedule-common/resources';

const resources = (): (
	| RouteResource<GetTimezonesResponse>
	| RouteResource<GetTimeTemplatesResponse>
	| RouteResource<UserResourceType>
)[] => [getTimezonesResource, getTimeTemplatesResource, ...eocCommonResources()];

export { resources };
